/*!
 * BOPF Email Preferences page hydrator
 *
 * Renders /pages/email-preferences with three automation toggles and
 * a master pause. Reads token from URL ?token=X, hydrates from server,
 * lets customer save changes.
 *
 * Install:
 *   1. Save as: assets/bopf-email-prefs.js
 *   2. Create Shopify page /pages/email-preferences (title: "Email Preferences").
 *      Page body content: <div id="bopf-prefs-app"></div>
 *   3. Add to layout/theme.liquid before </body>:
 *          {% if page.handle == 'email-preferences' %}
 *            <script src="{{ 'bopf-email-prefs.js' | asset_url }}?v=1" defer></script>
 *          {% endif %}
 */

(function() {
  'use strict';

  var ZARA_BACKEND = 'https://bopf-concierge.onrender.com';

  function log() {
    try { console.log.apply(console, ['[bopf-prefs]'].concat([].slice.call(arguments))); } catch(e) {}
  }

  function escapeHtml(s) {
    return String(s||'')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;');
  }

  function getToken() {
    try {
      var u = new URL(window.location.href);
      var t = (u.searchParams.get('token') || '').trim();
      return /^[a-z0-9]{16,32}$/.test(t) ? t : null;
    } catch(e) { return null; }
  }

  function injectStyles() {
    if (document.getElementById('bopf-prefs-styles')) return;
    var s = document.createElement('style');
    s.id = 'bopf-prefs-styles';
    s.textContent = '' +
      '#bopf-prefs-app { font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif; color: #1F1A17; max-width: 640px; margin: 0 auto; padding: 48px 24px 80px; }' +
      '@media (max-width: 600px) { #bopf-prefs-app { padding: 32px 20px 60px; } }' +

      '.bopf-pf-header { text-align: center; margin-bottom: 40px; }' +
      '.bopf-pf-eyebrow { font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; color: #A0563E; margin: 0 0 12px 0; }' +
      '.bopf-pf-title { font-family: Georgia, "Times New Roman", serif; font-size: 36px; font-weight: 400; color: #1F1A17; margin: 0 0 14px 0; line-height: 1.2; }' +
      '@media (max-width: 600px) { .bopf-pf-title { font-size: 28px; } }' +
      '.bopf-pf-title em { font-style: italic; color: #A0563E; position: relative; display: inline-block; }' +
      '.bopf-pf-title em:after { content: ""; position: absolute; left: 0; right: 0; bottom: -6px; height: 8px; ' +
        'background-image: url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 6"><path d="M2 3 Q 14 1, 24 3 T 44 3 T 64 3 T 88 3" stroke="%23A0563E" stroke-width="1.4" fill="none" stroke-linecap="round"/></svg>\');' +
        'background-repeat: no-repeat; background-size: 100% 100%; }' +
      '.bopf-pf-subtitle { font-family: Georgia, serif; font-style: italic; font-size: 16px; color: #666; margin: 0 auto; max-width: 480px; line-height: 1.5; }' +

      '.bopf-pf-email-line { text-align: center; margin: 24px 0 0; padding: 12px 16px; background: #FAF6F0; border-radius: 4px; ' +
        'font-size: 13px; color: #666; font-family: Georgia, serif; font-style: italic; }' +
      '.bopf-pf-email-line strong { font-style: normal; color: #1F1A17; font-family: -apple-system, sans-serif; font-weight: 500; }' +

      '.bopf-pf-toggle-card { display: flex; gap: 18px; align-items: flex-start; padding: 22px 0; border-bottom: 0.5px solid rgba(160, 86, 62, 0.15); }' +
      '.bopf-pf-toggle-card:last-of-type { border-bottom: none; }' +
      '.bopf-pf-toggle-info { flex: 1; min-width: 0; }' +
      '.bopf-pf-toggle-label { font-family: Georgia, serif; font-size: 17px; color: #1F1A17; margin: 0 0 6px 0; line-height: 1.35; }' +
      '.bopf-pf-toggle-label em { font-style: italic; color: #A0563E; }' +
      '.bopf-pf-toggle-desc { font-size: 13px; color: #666; line-height: 1.55; margin: 0; font-family: Georgia, serif; font-style: italic; }' +

      '.bopf-pf-switch { position: relative; flex-shrink: 0; width: 46px; height: 26px; cursor: pointer; }' +
      '.bopf-pf-switch input { opacity: 0; width: 0; height: 0; position: absolute; }' +
      '.bopf-pf-switch-slider { position: absolute; top: 0; left: 0; right: 0; bottom: 0; ' +
        'background: #d6cfc4; border-radius: 13px; transition: background 0.22s; }' +
      '.bopf-pf-switch-slider:before { content: ""; position: absolute; left: 3px; top: 3px; width: 20px; height: 20px; ' +
        'background: #fff; border-radius: 50%; transition: transform 0.22s; box-shadow: 0 1px 3px rgba(0,0,0,0.15); }' +
      '.bopf-pf-switch input:checked + .bopf-pf-switch-slider { background: #A0563E; }' +
      '.bopf-pf-switch input:checked + .bopf-pf-switch-slider:before { transform: translateX(20px); }' +
      '.bopf-pf-switch input:focus-visible + .bopf-pf-switch-slider { box-shadow: 0 0 0 3px rgba(160, 86, 62, 0.25); }' +

      '.bopf-pf-master-card { background: #FAF6F0; border-radius: 8px; padding: 20px 22px; margin: 28px 0 24px; ' +
        'display: flex; gap: 18px; align-items: flex-start; }' +
      '.bopf-pf-master-card .bopf-pf-toggle-info { flex: 1; }' +

      '.bopf-pf-save-row { display: flex; gap: 12px; align-items: center; margin-top: 16px; }' +
      '.bopf-pf-save-btn { padding: 13px 32px; background: #1F1A17; color: #FAF6F0; border: none; cursor: pointer; ' +
        'font-size: 12px; letter-spacing: 0.18em; text-transform: uppercase; transition: background 0.15s; ' +
        'font-family: -apple-system, sans-serif; }' +
      '.bopf-pf-save-btn:hover { background: #2c2521; }' +
      '.bopf-pf-save-btn:disabled { opacity: 0.6; cursor: not-allowed; }' +
      '.bopf-pf-status { font-size: 13px; color: #888; font-family: Georgia, serif; font-style: italic; min-height: 18px; }' +
      '.bopf-pf-status.saved { color: #5a9970; }' +
      '.bopf-pf-status.error { color: #a8443a; }' +

      '.bopf-pf-footer { margin-top: 36px; padding-top: 22px; border-top: 0.5px solid rgba(160, 86, 62, 0.15); ' +
        'font-size: 12px; color: #888; line-height: 1.6; text-align: center; font-family: Georgia, serif; font-style: italic; }' +

      '.bopf-pf-loading { text-align: center; padding: 60px 20px; }' +
      '.bopf-pf-loading-text { font-family: Georgia, serif; font-style: italic; color: #666; font-size: 15px; }' +
      '.bopf-pf-error-state { text-align: center; padding: 50px 20px; }' +
      '.bopf-pf-error-headline { font-family: Georgia, serif; font-style: italic; font-size: 22px; color: #1F1A17; margin: 0 0 14px 0; }' +
      '.bopf-pf-error-body { font-size: 14px; color: #666; line-height: 1.6; margin: 0 0 24px 0; }' +
      '.bopf-pf-error-cta { display: inline-block; padding: 13px 28px; background: #1F1A17; color: #FAF6F0; ' +
        'text-decoration: none; font-size: 11px; letter-spacing: 0.18em; text-transform: uppercase; }';
    document.head.appendChild(s);
  }

  function fetchPrefs(token) {
    return fetch(ZARA_BACKEND + '/zara/preferences/view?token=' + encodeURIComponent(token))
      .then(function(r){ return r.json(); });
  }

  function postPrefs(token, prefs) {
    return fetch(ZARA_BACKEND + '/zara/preferences/update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: token,
        studio_invites: prefs.studio_invites,
        price_drops: prefs.price_drops,
        personal_offers: prefs.personal_offers,
        master_pause: prefs.master_pause
      })
    }).then(function(r){ return r.json(); });
  }

  function renderToggle(id, labelHtml, desc, checked) {
    return '' +
      '<div class="bopf-pf-toggle-card">' +
        '<div class="bopf-pf-toggle-info">' +
          '<p class="bopf-pf-toggle-label">' + labelHtml + '</p>' +
          '<p class="bopf-pf-toggle-desc">' + escapeHtml(desc) + '</p>' +
        '</div>' +
        '<label class="bopf-pf-switch">' +
          '<input type="checkbox" data-bopf-toggle="' + id + '"' + (checked ? ' checked' : '') + ' />' +
          '<span class="bopf-pf-switch-slider"></span>' +
        '</label>' +
      '</div>';
  }

  function renderApp(email, prefs) {
    var root = document.getElementById('bopf-prefs-app');
    if (!root) return;

    var html = '' +
      '<div class="bopf-pf-header">' +
        '<p class="bopf-pf-eyebrow">From Hadiza</p>' +
        '<h1 class="bopf-pf-title">Your <em>email preferences</em></h1>' +
        '<p class="bopf-pf-subtitle">Choose what I write to you about. You\'re always in control.</p>' +
        (email ? '<div class="bopf-pf-email-line">Updating preferences for <strong>' + escapeHtml(email) + '</strong></div>' : '') +
      '</div>' +

      renderToggle(
        'studio_invites',
        'Studio <em>invitations</em>',
        'When you save a piece, I\'ll occasionally invite you to come see it in person at the Al Quoz studio. No pressure, just an open door.',
        prefs.studio_invites
      ) +
      renderToggle(
        'price_drops',
        'Price drop <em>alerts</em>',
        'When the price comes down on a piece you\'ve saved, I\'ll let you know. Once per drop, never spammy.',
        prefs.price_drops
      ) +
      renderToggle(
        'personal_offers',
        'Personal <em>offers</em>',
        'Occasionally, a private code on a piece you\'ve been keeping an eye on. Tied to your email, expires in 7 days.',
        prefs.personal_offers
      ) +

      '<div class="bopf-pf-master-card">' +
        '<div class="bopf-pf-toggle-info">' +
          '<p class="bopf-pf-toggle-label">Pause <em>everything</em></p>' +
          '<p class="bopf-pf-toggle-desc">If you\'d rather hear nothing at all, this stops every marketing email at once. Order confirmations and receipts will still arrive if you make a purchase.</p>' +
        '</div>' +
        '<label class="bopf-pf-switch">' +
          '<input type="checkbox" data-bopf-toggle="master_pause"' + (prefs.master_pause ? ' checked' : '') + ' />' +
          '<span class="bopf-pf-switch-slider"></span>' +
        '</label>' +
      '</div>' +

      '<div class="bopf-pf-save-row">' +
        '<button class="bopf-pf-save-btn" data-bopf-save>Save preferences</button>' +
        '<span class="bopf-pf-status" data-bopf-status></span>' +
      '</div>' +

      '<p class="bopf-pf-footer">Transactional emails (order confirmations, share notifications, account-related) will continue regardless of these preferences.</p>';

    root.innerHTML = html;
    wireActions(root);
  }

  function wireActions(root) {
    var saveBtn = root.querySelector('[data-bopf-save]');
    var statusEl = root.querySelector('[data-bopf-status]');

    function clearStatus() {
      statusEl.className = 'bopf-pf-status';
      statusEl.textContent = '';
    }

    root.querySelectorAll('[data-bopf-toggle]').forEach(function(input) {
      input.addEventListener('change', clearStatus);
    });

    saveBtn.addEventListener('click', function() {
      var token = getToken();
      if (!token) {
        statusEl.className = 'bopf-pf-status error';
        statusEl.textContent = 'Token missing. Reload the link from your email.';
        return;
      }
      var prefs = {
        studio_invites: !!root.querySelector('[data-bopf-toggle="studio_invites"]').checked,
        price_drops: !!root.querySelector('[data-bopf-toggle="price_drops"]').checked,
        personal_offers: !!root.querySelector('[data-bopf-toggle="personal_offers"]').checked,
        master_pause: !!root.querySelector('[data-bopf-toggle="master_pause"]').checked
      };
      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving...';
      statusEl.className = 'bopf-pf-status';
      statusEl.textContent = '';

      postPrefs(token, prefs).then(function(d) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save preferences';
        if (d.ok) {
          statusEl.className = 'bopf-pf-status saved';
          statusEl.textContent = 'Saved. Thank you.';
          setTimeout(clearStatus, 4000);
        } else {
          statusEl.className = 'bopf-pf-status error';
          statusEl.textContent = d.error || 'Could not save. Please try again.';
        }
      }).catch(function(err) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save preferences';
        statusEl.className = 'bopf-pf-status error';
        statusEl.textContent = 'Connection error. Please try again.';
        log('save error:', err);
      });
    });
  }

  function renderError(reason) {
    var root = document.getElementById('bopf-prefs-app');
    if (!root) return;
    var headline, body;
    if (reason === 'no_token' || reason === 'invalid_token') {
      headline = 'This link isn\'t valid.';
      body = 'It may be mistyped, expired, or for an account that no longer exists. If you continue receiving emails you don\'t want, please reply to any email from us and I\'ll handle it personally.';
    } else if (reason === 'connection') {
      headline = 'Connection trouble.';
      body = 'Couldn\'t load your preferences. Please try refreshing the page.';
    } else {
      headline = 'Something went wrong.';
      body = 'Please try refreshing, or reply to any email from us if it persists.';
    }
    root.innerHTML = '' +
      '<div class="bopf-pf-header">' +
        '<p class="bopf-pf-eyebrow">From Hadiza</p>' +
        '<h1 class="bopf-pf-title">Email <em>preferences</em></h1>' +
      '</div>' +
      '<div class="bopf-pf-error-state">' +
        '<p class="bopf-pf-error-headline">' + escapeHtml(headline) + '</p>' +
        '<p class="bopf-pf-error-body">' + escapeHtml(body) + '</p>' +
        '<a href="/collections/all" class="bopf-pf-error-cta">Browse pieces</a>' +
      '</div>';
  }

  function renderLoading() {
    var root = document.getElementById('bopf-prefs-app');
    if (!root) return;
    root.innerHTML = '' +
      '<div class="bopf-pf-header">' +
        '<p class="bopf-pf-eyebrow">From Hadiza</p>' +
        '<h1 class="bopf-pf-title">Your <em>email preferences</em></h1>' +
      '</div>' +
      '<div class="bopf-pf-loading">' +
        '<p class="bopf-pf-loading-text">Loading your preferences...</p>' +
      '</div>';
  }

  function boot() {
    injectStyles();
    var root = document.getElementById('bopf-prefs-app');
    if (!root) {
      log('no #bopf-prefs-app element found');
      return;
    }
    var token = getToken();
    if (!token) {
      renderError('no_token');
      return;
    }
    renderLoading();
    fetchPrefs(token).then(function(d) {
      if (d.ok) {
        renderApp(d.email, d.prefs);
      } else {
        renderError(d.error === 'not_found' ? 'invalid_token' : 'unknown');
      }
    }).catch(function(err) {
      log('load failed:', err);
      renderError('connection');
    });
  }

  log('script parsed, readyState =', document.readyState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
